import styled from 'styled-components';

interface MainContainerProps {
  isMobile?: boolean;
  padding?: string;
}

const MainContainer = styled.div<MainContainerProps>`
  width: 100%;
  height: calc(100vh - ${(props) => (props.isMobile ? '180px' : '70px')});
  overflow-y: auto;
  padding: ${(props) => (props.padding ? props.padding : '0')};

  @media (max-width: 767px) {
    ${(props) => !props.isMobile && 'height: calc(100vh - 120px);'}
  }
`;

export default MainContainer;
